import $ from "jquery";
import "slick-carousel";

const categoriesSlider = () => {
  const target = ".wapp-product-categories__slider";
  const filterTarget = ".js-category"; 
  const $target = $(target);
  var currentUrl = window.location.href;


  const init = () => {
    $(document).ready(function () {
      if(filterTarget.length) {
        filter()
      }
      if ($target.length) {
        slider();
      }
      if (!currentUrl.includes('/shop/')) {
        shopPageFiltered();
      }
    });
  };

  const slider = () => {
    $target.slick({
      slidesToShow: 4  ,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: "unslick",
        },
      ],
    });
  };

  const filter = () => {
    $(".js-category").on('click', function() {
      const dataCat = $(this).attr('data-cat');
      localStorage.removeItem('dataCat');
      localStorage.removeItem('dataBrand');
      localStorage.setItem('dataCat', dataCat);
    })
    
    $(".js-brand-card").on('click', function() {
      const dataBrand = $(this).attr('data-brand');
      localStorage.removeItem('dataCat');
      localStorage.removeItem('dataBrand');
      localStorage.setItem('dataBrand', dataBrand);
    })
  }

  const shopPageFiltered = () => {
    var currentUrl = window.location.href;
    const dataCat = localStorage.getItem('dataCat');
    const dataBrand = localStorage.getItem('dataBrand');
    const filterCatRadio = $('.woof_container_radio li');
    const filterCatCheckbox = $('.woof_container_product_cat li');

    filterCatRadio.on('click', function() {
      localStorage.removeItem('dataBrand');
    })

    filterCatCheckbox.on('click', function() {
      localStorage.removeItem('dataCat');
    })
    
    // filterCatRadio.each(function() {
    //     if ($(this).attr('name') !== dataBrand) {
    //         $(this).attr('disabled', true);
    //     }
    //     if (currentUrl.includes('/shop/')) {
    //       $(this).attr('disabled', false);
    //     }
    // });
    
    // filterCatCheckbox.each(function() {
    //     if ($(this).data('slug') !== dataCat) {
    //         $(this).attr('disabled', true);
    //     }
    //     if (currentUrl.includes('/shop/')) {
    //       $(this).attr('disabled', false);
    //     }
    // });
    
    // $(`.woof_container_product_cat .woof_checkbox_term[name='${dataCat}']`).attr('checked', 'checked');
    // $(`.woof_container_inner_brands .woof_radio_term[data-slug='${dataBrand}']`).attr('checked', 'checked');

    $(`.woof_container_inner_brands .woof_checkbox_term[name='${dataBrand}']`).attr('checked', 'checked');
    $(`.woof_container_product_cat .woof_radio_term[data-slug='${dataCat}']`).attr('checked', 'checked');
    
    if (currentUrl.includes('/shop/')) {
      localStorage.removeItem('dataCat');
      localStorage.removeItem('dataBrand');
    }
  }

  init();
};

try {
  categoriesSlider();
} catch (error) {
  throw Error(error);
}
